"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternDrawer = InternDrawer;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _TenantDetail = _interopRequireDefault(require("./TenantDetail"));
var _core = require("@focaltec-suite/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DrawerNav = (0, _styles.styled)('nav')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    backgroundColor: theme.palette.background.paper
  }, theme.breakpoints.up('md'), {
    flexShrink: 0,
    display: 'flex'
  });
});
function InternDrawer(_ref3) {
  var tenantId = _ref3.tenantId,
    routes = _ref3.routes;
  var layoutContext = (0, _react.useContext)(_core.LayoutContext);
  return /*#__PURE__*/_react["default"].createElement(DrawerNav, {
    sx: {
      '& .MuiDrawer-paper': {
        width: layoutContext.drawer.width
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Drawer, {
    id: "drawer",
    anchor: "left",
    variant: layoutContext.mobile ? 'temporary' : 'persistent',
    open: !layoutContext.mobile || layoutContext.drawer.open,
    onClose: layoutContext.mobile ? function () {
      return layoutContext.openDrawer(false, false);
    } : undefined
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    id: "drawer-menu",
    sx: function sx(theme) {
      return {
        visibility: layoutContext.drawer.open ? 'visible' : 'hidden',
        minWidth: layoutContext.mobile ? layoutContext.drawer.width : 'unset',
        marginTop: theme.spacing(8)
      };
    }
  }, /*#__PURE__*/_react["default"].createElement(_TenantDetail["default"], null), /*#__PURE__*/_react["default"].createElement(_core.AppMenu, {
    tenantId: tenantId,
    routes: routes
  }))));
}